import { styled } from 'styled-components';
import { timeAnswer } from '~/data/constantes';
import { classic } from '~/themes';
//import { classic } from '~/themes/classic';

type IProps = {
  timeLeft: number;
};

type TProps = IProps; // & ReturnType<typeof mapStateToProps> & TRootAction

export function TimerItem({ timeLeft }: TProps) {
  return (
    <Container>
      <SDivContent $timeLeft={timeLeft} $timeUsed={timeAnswer - timeLeft}>
        <SSpanTimer $isTimeOut={timeLeft <= 0}>
          {timeLeft > 0 ? `${timeLeft}”` : `0”`}
        </SSpanTimer>
      </SDivContent>
    </Container>
  );
}

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  border-radius: 50%;
  border: 3px solid white;
  background-color: #b0b0b0;
  display: flex;
  justify-content: center;

  pointer-events: none;
  user-select: none;
  overflow: hidden;
  height: 80px;
  width: 80px;

  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (max-width: 450px) {
    width: 50px;
    height: 50px;
    bottom: -25px;
  }
  @media screen and (max-height: 800px) {
    width: 50px;
    height: 50px;
    bottom: -25px;
  }
`;

const SDivContent = styled.div<{ $timeLeft?: number; $timeUsed?: number }>`
  align-items: center;
  display: flex;
  border-radius: 50%;
  justify-content: center;
  background: ${({ $timeLeft, $timeUsed }) => {
    if ($timeLeft !== undefined && $timeUsed !== undefined) {
      return `conic-gradient(#EA7A49 0deg ${$timeLeft * 18}deg, #505050 ${$timeLeft * 18}deg 360deg)`;
    }
    return 'none';
  }};
  transition: all 0.5s linear;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.25) inset;
  height: 68px;
  width: 68px;

  @media screen and (max-width: 450px) {
    width: 38px;
    height: 38px;
  }
  @media screen and (max-height: 800px) {
    width: 38px;
    height: 38px;
  }
`;

const SSpanTimer = styled.span<{ $isTimeOut?: boolean }>`
  color: ${({ $isTimeOut }) =>
    $isTimeOut
      ? `${classic.token?.colorError}`
      : `${classic.token?.colorWhite}`};
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.7rem;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #113969;

  @media screen and (max-height: 800px) {
    font-size: 1.3rem;
  }

  @media screen and (max-height: 415px) {
    font-size: 1.1rem;
  }

  @media screen and (max-width: 450px) {
    font-size: 1.1rem;
  }
`;
